import {Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy} from "@angular/core";

interface IHeaders {
	field?: string;
	label?: string;
	type?: string;
	choices?: any[];
	op?: string;
	data?: any;
}
@Component({
	selector: "app-search-text-filter",
	template: `
		<div class="field">
			<input type="text" placeholder="enter text to search this field" [(ngModel)]="field.data" />
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFilter {
	@Input() field: IHeaders;

	@Input() index: number;

	@Output() query = new EventEmitter();

	constructor() {}

	// text field survey question type
	textField(value) {
		this.field.data = value;
		this.query.emit({field: this.field, index: this.index});
	}
}
